import React, { useState, useEffect } from 'react';
import { apiRequest } from './utils';
import './Statistics.css';
import translations from './lang';

const Statistics = () => {
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const language = localStorage.getItem('language') || 'ro';
  const t = translations[language];

  useEffect(() => {
    fetchStatistics();
    // eslint-disable-next-line
  }, []);

  const fetchStatistics = () => {
    apiRequest(`${process.env.REACT_APP_API}/api/statistics/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        'Accept-Language': language
      },
    })
      .then(response => response.json())
      .then(data => {
        setStatistics(data);
      })
      .catch(() => setError(t.statistics_error))
      .finally(() => setLoading(false));
  };

  if (loading) return <div className="stats-loading">{t.loading_data}</div>;
  if (error) return <div className="stats-error">{error}</div>;

  return (
    <div className="statistics-container">
      <h2>{t.statistics}</h2>

      {statistics && (
        <>
          {/* Fő statisztikai kártyák */}
          <div className="stats-cards">
            <div className="stats-card">
              <h4>{t.total_bookings}</h4>
              <p>{statistics.totalBookings}</p>
            </div>
            <div className="stats-card">
              <h4>{t.most_booked_service}</h4>
              <p>{statistics.mostBookedService}</p>
            </div>
            <div className="stats-card">
              <h4>{t.total_services}</h4>
              <p>{statistics.totalServices}</p>
            </div>
          </div>

          {/* Szolgáltatás szerinti bontás */}
          <div className="stats-section">
            <h3>{t.bookings_by_service}</h3>
            <div className="stats-list">
              {statistics.bookingsByService.map((item, idx) => (
                <div key={idx} className="stats-list-item">
                  <span>{item.name}</span>
                  <span className="badge">{item.total}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Csomag szerinti bontás */}
          {statistics.bookingsByPackage.length > 0 && (
            <div className="stats-section">
              <h3>{t.bookings_by_package}</h3>
              <div className="stats-list">
                {statistics.bookingsByPackage.map((item, idx) => (
                  <div key={idx} className="stats-list-item">
                    <span>{item.name}</span>
                    <span className="badge">{item.total}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Statistics;
